export function isRejectedStatus(assessmentStatus?: string, comment?: string) {
  return assessmentStatus === "REJECTED" && (comment?.trim().length ?? 0) > 0;
}
